import {useCallback, useEffect, useRef, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {isProdMode} from "../../../constants/mode";
import {requestControllers} from "../../../redux/Actions/controllers.actions";
import {getControllersList} from "../../../redux/Selectors/controllers.selectors";
import {generateQueryUrl} from "../../../helpers/generateQueryUrl";
import {useGetControllerListUrl} from "./useGetControllerListUrl";

export const useControllersTableData = () => {
  const dispatch = useDispatch();
  const {controllerListURL} = useGetControllerListUrl();
  const intervalRef = useRef();
  const controllers = useSelector(getControllersList);
  const [pageURL, setPageURL] = useState("");

  const clearTimeInterval = useCallback(() => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
    }
  }, []);

  useEffect(() => {
    const dataCall = (trackThisPromise = false) => {
      dispatch(requestControllers(pageURL, trackThisPromise));
    };
    clearTimeInterval();
    dataCall(true);
    if (isProdMode) {
      intervalRef.current = setInterval(dataCall, 20000);
    }
    return clearTimeInterval;
  }, [clearTimeInterval, dispatch, pageURL]);

  const handleSearch = (tokens) => {
    if (tokens?.length > 0) {
      setPageURL(generateQueryUrl(controllerListURL, tokens));
    } else {
      setPageURL("");
    }
  };

  return {controllers, handleSearch};
};
